<template>
  <div class="app-container">
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      label-width="70px"
      style="width:90%;height:700px;margin-left:50px;"
    >
      <el-form-item label="店铺名称" prop="shopName" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.name" placeholder />
        </el-col>
      </el-form-item>
      <el-form-item label="账户" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.username" placeholder />
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="所在地" prop label-width="130px" :inline="true" >
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select placeholder="省" v-model="form.province_id" @change="getCityList(1)">
              <el-option
                v-for="item in provinceList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select
              placeholder="市"
              v-model="form.city_id"
              @change="getDistrictsList()"
              v-if="this.form.province_id"
            >
              <el-option
                v-for="item in cityList"
                :key="item.city_id"
                :label="item.name"
                :value="item.city_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select placeholder="区" v-model="form.district_id" v-if="this.form.city_id">
              <el-option
                v-for="item in districtList"
                :key="item.district_id"
                :label="item.name"
                :value="item.district_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-form-item>-->
      <el-form-item label="详细地址(非必填)" prop="description" label-width="130px">
        <el-col :span="13">
          <el-input type="textarea" :rows="3" v-model="form.address" />
        </el-col>
      </el-form-item>
      <el-form-item label="联系人" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.contact_name" placeholder />
        </el-col>
      </el-form-item>
      <el-form-item label="联系人电话" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.contact_phone" placeholder />
        </el-col>
      </el-form-item>
      <el-form-item label="客服电话" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.service_phone" placeholder />
        </el-col>
      </el-form-item>
      <el-form-item label="经纬度(非必填)" label-width="130px">
        <el-col :md="6">
          <div style="display:flex;">
          <el-input :disabled="true" v-model="position"></el-input>
          
          <el-button @click="clearPosition" type="danger" style="margin:0 0 0 10px">清除经纬度</el-button></div>
        </el-col>
        <el-col :span="24" style="margin-top:15px;">
          <amap-position ref="map" @choosePosition="choosePosition" :height="300"></amap-position>
        </el-col>
      </el-form-item>
    </el-form>
    <el-col :span="24">
      <div style="margin:0 auto;width:200px;line-height:60px;">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-col>
  </div>
</template>

<script>
import UploadOne from "@/components/UploadOne/index.vue";
import Tinymce from "@/components/Tinymce";
import request from "@/utils/request";
import AMapPosition from "@/components/AMapPosition";
export default {
  components: {
    "amap-position": AMapPosition,
    Tinymce,
    UploadOne
  },
  data() {
    return {
      listLoading: false,
      position: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      btnLoading: false,
      typeInfo: [],
      classify: [],
      form: {
        id: "",
        name: "",
        username: "",
        password: "123456",
        province_id: "",
        city_id: "",
        district_id: "",
        contact_name: "",
        contact_phone: "",
        address: "",
        latitude: "",
        longitude: ""
      },
      id: "",
      limit: true,
      provinces: [],
      cities: [],
      positionNum: "",
      selectIdx: "",
      showMap: false
    };
  },
  mounted() {
    this.getProvinceList();
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: "",
        name: "",
        username: "",
        password: "123456",
        province_id: "",
        city_id: "",
        district_id: "",
        contact_name: "",
        contact_phone: "",
        address: "",
        latitude: "",
        longitude: ""
      };
      this.btnLoading = false;
    },
    getData() {
      this.listLoading = true;
      request({
        url: "/api/backend/shop/detail",
        method: "get",
        params: {
          id: this.id
        }
      }).then(res => {
        this.form = res.data;
        this.getCityList();
        this.getDistrictsList();
        this.form.province_id = this.form.province_id.toString();
        this.form.city_id = this.form.city_id.toString();
        this.form.district_id = this.form.district_id.toString();
        this.position = this.form.latitude + "," + this.form.longitude;
        if (!this.form.latitude) {
          this.position = "";
        }
        this.listLoading = false;
      });
    },
    clearPosition() {
      this.position = "";
      this.form.latitude = "";
      this.form.longitude = "";
    },
    // getProvince() {
    //   return request({
    //     url: "/api/common/area/index",
    //     method: "get"
    //   }).then(res => {
    //     this.provinces = res.data;
    //   });
    // },
    choosePosition(res) {
      console.log(res);
      this.position = res.position.lat + "," + res.position.lng;
      this.form.latitude = res.position.lat;
      this.form.longitude = res.position.lng;
      this.form.address = res.address;
    },
    getCities(idx) {
      this.cities = [];
      if (!this.form.match_club[idx].province_id) {
        return;
      }
      request({
        url: "/api/common/area/cities",
        method: "get",
        params: {
          province_id: this.form.match_club[idx].province_id
        }
      }).then(res => {
        this.cities = res.data;
      });
    },
    clearCity(idx) {
      this.form.match_club[idx].city_id = "";
    },
    clearPro(idx) {
      this.form.match_club[idx].province_id = "";
    },
    clickLL(idx) {
      this.showMap = true;
      this.selectIdx = idx;
      if (
        this.form.match_club[this.selectIdx].longitude &&
        this.form.match_club[this.selectIdx].latitude
      ) {
        this.$nextTick(() => {
          this.$refs["map"].setCenter(
            this.form.match_club[this.selectIdx].longitude,
            this.form.match_club[this.selectIdx].latitude
          );
        });
      }
    },
    getMap(res) {
      this.form.match_club[this.selectIdx].latitude = res.position.lat;
      this.form.match_club[this.selectIdx].longitude = res.position.lng;
      this.showMap = false;
    },
    addClub() {
      let obj = {
        name: "",
        province_id: "",
        city_id: "",
        address: "",
        latitude: "",
        longitude: ""
      };
      this.form.match_club.push(obj);
    },
    delClub(idx) {
      this.form.match_club.splice(idx, 1);
    },
    // 提交
    handler() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.limit) {
            this.form.number_limitation = 0;
          }
          this.btnLoading = true;
          request({
            url: "/api/backend/match",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.$router.push("/information/list");
            })
            .catch(err => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/shop",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.goBack();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getProvinceList() {
      request({
        url: "/api/common/area/index",
        method: "get",
        params: ""
      }).then(response => {
        this.provinceList = response.data;
      });
    },
    getCityList(type) {
      if (type == 1) {
        this.form.city_id = "";
        this.form.district_id = "";
      }
      request({
        url: "/api/common/area/cities",
        method: "get",
        params: { province_id: this.form.province_id }
      }).then(response => {
        this.cityList = response.data;
      });
    },
    getDistrictsList() {
      request({
        url: "/api/common/area/districts",
        method: "get",
        params: { city_id: this.form.city_id }
      }).then(response => {
        this.districtList = response.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>

